var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.14,
    height: 68.916,
    viewBox: "0 0 52.14 68.916",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-teacher-2463963",
    transform: "translate(-20.69 -6.799)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6422",
    "data-name": "Path 6422",
    d: "M55.052,68.025a.6.6,0,0,1-.6-.6V63.652a.6.6,0,1,1,1.2,0v3.771a.6.6,0,0,1-.6.6Z",
    transform: "translate(-13.424 -22.368)",
    fill: "#254895"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6423",
    "data-name": "Path 6423",
    d: "M21.292,100.577a.6.6,0,0,1-.6-.6V87.536a13.372,13.372,0,0,1,6.728-10.312l13.914-7.831a.6.6,0,0,1,.566,0L46.718,71.8l4.819-2.409a.6.6,0,0,1,.566,0l13.914,7.831a13.384,13.384,0,0,1,6.813,11.65V99.915a.6.6,0,0,1-.6.6l-50.977.054Zm.6-12.945v11.74l49.773-.054V88.874a12.18,12.18,0,0,0-6.216-10.6L51.826,70.6l-4.819,2.409a.6.6,0,0,1-.542,0L41.646,70.6,28.009,78.272a12.168,12.168,0,0,0-6.114,9.355Z",
    transform: "translate(0 -24.862)",
    fill: "#254895"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6424",
    "data-name": "Path 6424",
    d: "M79.773,64.15a.6.6,0,0,1-.2-1.169l6.957-2.488a.675.675,0,0,0,.422-.819L83.453,47.423a.6.6,0,0,1,1.157-.331L88.1,59.344a1.885,1.885,0,0,1-1.2,2.283l-6.921,2.488A.6.6,0,0,1,79.773,64.15Z",
    transform: "translate(-23.255 -15.861)",
    fill: "#254895"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6425",
    "data-name": "Path 6425",
    d: "M42.128,64.15a.6.6,0,0,1-.2-.036l-6.957-2.482a1.879,1.879,0,0,1-1.175-2.289l3.5-12.252a.6.6,0,0,1,1.157.331L34.954,59.675a.675.675,0,0,0,.422.819l6.945,2.488a.6.6,0,0,1-.2,1.169Z",
    transform: "translate(-5.181 -15.861)",
    fill: "#254895"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6426",
    "data-name": "Path 6426",
    d: "M52.152,53.214A14.559,14.559,0,0,1,38.014,42.371a3.795,3.795,0,0,1-.506-7.541V33.462a.6.6,0,1,1,1.2,0v1.891a.6.6,0,0,1-.6.6,2.59,2.59,0,0,0,0,5.18,1.361,1.361,0,0,0,.187,0h.108a.6.6,0,0,1,.657.464,13.426,13.426,0,0,0,26.172,0,.6.6,0,0,1,.657-.464h.114a1.392,1.392,0,0,0,.187,0,2.59,2.59,0,1,0,0-5.18.6.6,0,0,1,0-1.2,3.795,3.795,0,0,1,.1,7.584A14.559,14.559,0,0,1,52.152,53.214Z",
    transform: "translate(-5.416 -10.363)",
    fill: "#254895"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6427",
    "data-name": "Path 6427",
    d: "M55.2,88.317a10.107,10.107,0,0,1-9.144-5.7L43.8,78.047a.6.6,0,0,1,1.084-.53l2.235,4.566a8.969,8.969,0,0,0,16.119,0L67,74.391,60.29,70.6l-4.819,2.409a.6.6,0,0,1-.542,0L50.11,70.6l-7.228,4.066a.6.6,0,0,1-.6-1.048L49.785,69.4a.6.6,0,0,1,.566,0l4.819,2.409L59.989,69.4a.6.6,0,0,1,.566,0l7.505,4.216a.6.6,0,0,1,.247.789l-3.97,8.2A10.107,10.107,0,0,1,55.2,88.317Z",
    transform: "translate(-8.464 -24.866)",
    fill: "#254895"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6428",
    "data-name": "Path 6428",
    d: "M72.012,68.025a.6.6,0,0,1-.6-.6V63.652a.6.6,0,1,1,1.2,0v3.771A.6.6,0,0,1,72.012,68.025Z",
    transform: "translate(-20.169 -22.368)",
    fill: "#254895"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6429",
    "data-name": "Path 6429",
    d: "M35.982,111.889a.6.6,0,0,1-.6-.6V98.522a.6.6,0,0,1,1.2,0v12.764A.6.6,0,0,1,35.982,111.889Z",
    transform: "translate(-5.841 -36.234)",
    fill: "#254895"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6430",
    "data-name": "Path 6430",
    d: "M91.082,111.889a.6.6,0,0,1-.6-.6V98.522a.6.6,0,1,1,1.2,0v12.764A.6.6,0,0,1,91.082,111.889Z",
    transform: "translate(-27.752 -36.234)",
    fill: "#254895"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6431",
    "data-name": "Path 6431",
    d: "M51.313,40.667a4.433,4.433,0,1,1,4.433-4.433,4.433,4.433,0,0,1-4.433,4.433Zm0-7.662a3.229,3.229,0,1,0,3.229,3.229A3.229,3.229,0,0,0,51.313,33Z",
    transform: "translate(-10.414 -9.942)",
    fill: "#254895"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6432",
    "data-name": "Path 6432",
    d: "M70.7,40.667a4.433,4.433,0,1,1,4.445-4.433A4.433,4.433,0,0,1,70.7,40.667ZM70.7,33a3.229,3.229,0,1,0,2.291.941A3.229,3.229,0,0,0,70.7,33Z",
    transform: "translate(-18.129 -9.942)",
    fill: "#254895"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6433",
    "data-name": "Path 6433",
    d: "M61.439,53.571A5.7,5.7,0,0,1,57.861,52.3a.6.6,0,0,1,.753-.94,4.482,4.482,0,0,0,5.626,0l.747.94A5.668,5.668,0,0,1,61.439,53.571Z",
    transform: "translate(-14.697 -17.672)",
    fill: "#254895"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6434",
    "data-name": "Path 6434",
    d: "M44.668,37.2H40.222a.6.6,0,1,1,0-1.2h4.445a.6.6,0,1,1,0,1.2Z",
    transform: "translate(-7.527 -11.612)",
    fill: "#254895"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6435",
    "data-name": "Path 6435",
    d: "M83.892,37.2H79.422a.6.6,0,1,1,0-1.2h4.469a.6.6,0,1,1,0,1.2Z",
    transform: "translate(-23.115 -11.612)",
    fill: "#254895"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6436",
    "data-name": "Path 6436",
    d: "M64.292,37.2H59.822a.6.6,0,1,1,0-1.2h4.469a.6.6,0,0,1,0,1.2Z",
    transform: "translate(-15.321 -11.612)",
    fill: "#254895"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6437",
    "data-name": "Path 6437",
    d: "M63.532,90.006a.6.6,0,0,1-.6-.6V74.182a.6.6,0,1,1,1.2,0V89.4A.6.6,0,0,1,63.532,90.006Z",
    transform: "translate(-16.797 -26.555)",
    fill: "#254895"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6438",
    "data-name": "Path 6438",
    d: "M81.355,28.54a.6.6,0,0,1-.44-.193l-8.3-8.909a.6.6,0,0,1,0-.849l4.469-4.216a.6.6,0,0,1,.416-.163,4.439,4.439,0,0,1,4.433,4.433v9.294a.6.6,0,0,1-.578.6ZM73.9,19.053l6.849,7.373V18.643a3.229,3.229,0,0,0-3.012-3.217Z",
    transform: "translate(-20.578 -2.947)",
    fill: "#254895"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6439",
    "data-name": "Path 6439",
    d: "M36.962,21.593a.6.6,0,0,1-.6-.6v-.819a9.015,9.015,0,0,1,.042-1.066c-.09-.741-.458-5.861,6.114-10.2A13.029,13.029,0,0,1,49.744,6.8h9.993a3.783,3.783,0,0,1,2.554,6.584l-3.229,2.939a.6.6,0,0,1-.265.139L37.113,21.569ZM49.726,8a11.83,11.83,0,0,0-6.548,1.934h0C36.884,14.088,37.595,18.967,37.6,19a.6.6,0,0,1,0,.145c0,.337-.042.687-.042,1.03v.066L58.37,15.353l3.108-2.831a2.59,2.59,0,0,0-1.741-4.506Zm-6.879,1.41Z",
    transform: "translate(-6.231 0)",
    fill: "#254895"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudents);
export default __webpack_public_path__ + "static/media/students.f5a23286186f7506b5f62ade0907d2e5.svg";
export { ForwardRef as ReactComponent };